import React, { ReactElement } from "react";
import "./../../assets/scss/components/layout.scss"
interface PageHeaderProps {
    withoutBottomPadding?: boolean;
    children?: React.ReactNode;
    title?: string;
}

const PageHeader: React.FC<PageHeaderProps> = (props: PageHeaderProps = { withoutBottomPadding: true, children: <></>, title: "" }): ReactElement => {
    return (
        <div className={`bg-blue-medium ${props.withoutBottomPadding ? 'pt-3' : 'py-3'}`}>
            <div className="uk-container-large" style={{ minHeight: 'unset' }}>
                <h1 className={`caption ${props.withoutBottomPadding ? 'mb-4' : 'mb-3'} mt-3`} style={{ textAlign: 'left', color: '#00cbd8' }}>{props.title}</h1>
                {props.children}
            </div>
        </div>
    )
}

export { PageHeader }
export type { PageHeaderProps }